import { Component } from '@angular/core';

@Component({
    selector: 'app',
    template: `<router-outlet></router-outlet>`,
    standalone: false
})
export class AppComponent {

}
